import React from 'react'
import { Grid } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import { useDialog } from '../../providers/dialog-provider'
import {
  HowToAddDoseModal,
  HowToInviteFriendsModal,
  HowToUseTheAppModal,
  WhatIsDailyDoseModal,
} from '../../components'
import { HowToCreateCircleModal } from '../../components/how-to-create-circle-modal'
import Box from '@material-ui/core/Box'
import { createStyles, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() =>
  createStyles({
    strong: {
      fontWeight: 'bold',
    },
  })
)

const HelpAndSupportPage = () => {
  const { openDialog, closeDialog } = useDialog()
  const classes = useStyles()

  const onOpenWhatIsDailyDoseModal = () => {
    openDialog({
      color: 'primary',
      title: 'What is the daily dose?',
      confirmText: '',
      custom: true,
      description: <WhatIsDailyDoseModal onCloseInfoModal={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  const onOpenHowToUseTheAppModal = () => {
    openDialog({
      color: 'primary',
      title: 'How to use the app?',
      confirmText: '',
      custom: true,
      description: <HowToUseTheAppModal onCloseInfoModal={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  const onOpeHowToAddDoseModal = () => {
    openDialog({
      color: 'primary',
      title: 'How do I add a dose?',
      confirmText: '',
      custom: true,
      description: <HowToAddDoseModal onCloseInfoModal={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  const onOpeHowToCreateCircleModal = () => {
    openDialog({
      color: 'primary',
      title: 'How can I create a group?',
      confirmText: '',
      custom: true,
      description: <HowToCreateCircleModal onCloseInfoModal={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  const onOpeHowToInviteFriendsModal = () => {
    openDialog({
      color: 'primary',
      title: 'How can I invite my friends?',
      confirmText: '',
      custom: true,
      description: (
        <HowToInviteFriendsModal onCloseInfoModal={() => closeDialog()} />
      ),
      fullScreen: true,
    })
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h4">Getting started</Typography>
      </Grid>
      <Grid item xs={12}>
        <List component="nav">
          <ListItem button onClick={onOpenWhatIsDailyDoseModal}>
            <ListItemText primary="What is the daily dose?" />
          </ListItem>
          <Divider />
          <ListItem button onClick={onOpenHowToUseTheAppModal}>
            <ListItemText primary="How to use the app?" />
          </ListItem>
          <Divider />
          <ListItem button onClick={onOpeHowToAddDoseModal}>
            <ListItemText primary="How do I add a dose?" />
          </ListItem>
          <Divider />
          <ListItem button onClick={onOpeHowToCreateCircleModal}>
            <ListItemText primary="How can I create a group?" />
          </ListItem>
          <Divider />
          <ListItem button onClick={onOpeHowToInviteFriendsModal}>
            <ListItemText primary="How can I invite my friends?" />
          </ListItem>
          <Divider />
        </List>
      </Grid>
      <Grid item xs={12}>
        <Box mt={2}>
          <Typography variant="body1">Still need help?</Typography>
          <Typography variant="body1">
            <span className={classes.strong}>Message us: </span>
            dailydosers.help@gmail.com
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default HelpAndSupportPage
